import script from "./ManageReview.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageReview.vue?vue&type=script&setup=true&lang=js"

import "./ManageReview.vue?vue&type=style&index=0&id=56c2d0df&lang=scss"

const __exports__ = script;

export default __exports__